import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInputForm: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="input-form, text-area, prompt, rename"><path d="M11 6.75H21.25V17.25H11" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 6.75H2.75V17.25H6.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8.75 3V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconInputForm;
